import {Routes, RouterModule} from '@angular/router';
import { SingleSubmissionHistoryComponent } from './single-submission-history/single-submission-history.component';
import { MassSubmissionHistoryComponent } from './mass-submission-history/mass-submission-history.component';
import { MassSearchCustomersHistoryComponent } from './mass-search-customers-history/mass-search-customers-history.component';
import { ActivityHistoryComponent } from './activity-history/activity-history.component';
import { HomeLayoutComponent } from '../home-layout/home-layout.component';
import { TelcoAuditTrailComponent } from './telco-audit-trail.component';
import { EnquiryHistoryByOtherComponent } from './enquiry-history-by-other/enquiry-history-by-other.component';

const telcoAuditTrailRoutes: Routes = [
	// {path: 'telco-audit-trail/single-submission-history', component: SingleSubmissionHistoryComponent, pathMatch: 'full'},
	// {path: 'telco-audit-trail/mass-submission-history', component: MassSubmissionHistoryComponent},
	// {path: 'telco-audit-trail/mass-search-customers-history', component: MassSearchCustomersHistoryComponent},
	// {path: 'telco-audit-trail/activity-history', component: ActivityHistoryComponent}
	{
		path: 'telco-audit-trail',                      
	    component: HomeLayoutComponent,
	    children: [
	    	{
			    path: '',                      
			    component: TelcoAuditTrailComponent,
			    // children: [
					
			    // ]
			},
			{path: 'single-submission-history', component: SingleSubmissionHistoryComponent},
			{path: 'mass-submission-history', component: MassSubmissionHistoryComponent},
			{path: 'mass-search-customers-history', component: MassSearchCustomersHistoryComponent},
			{path: 'activity-history', component: ActivityHistoryComponent},
			{path: 'enquiry-history-by-other', component: EnquiryHistoryByOtherComponent}
		]
	},
]


export const telcoAuditTrailRouting = RouterModule.forChild(telcoAuditTrailRoutes);



// WEBPACK FOOTER //
// ./src/app/telco-audit-trail/telco-audit-trail.routing.ts